// packages/hooks/src/useDashboard.ts
import { useState, useEffect } from 'react';
import { AdminDashboardStats, ShopDashboardStats, ClientDashboardStats } from '@cabukaka/types';
import { dashboardService } from '@cabukaka/services';
import { useToken } from '../auth/useToken';

export function useAdminDashboard() {
    const { token } = useToken();
    const [data, setData] = useState<AdminDashboardStats | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchDashboard = async () => {
            if (!token) {
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                const result = await dashboardService.getAdminStats(token);
                setData(result);
                console.log(result)
            } catch (err: any) {
                setError(err.message || "Erreur lors du chargement");
            } finally {
                setLoading(false);
            }
        };

        fetchDashboard();
    }, [token]);

    return { data, loading, error };
}

export function useShopDashboard() {
    const { token } = useToken();
    const [data, setData] = useState<ShopDashboardStats | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchDashboard = async () => {
            if (!token) {
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                const result = await dashboardService.getShopStats(token);
                setData(result);
            } catch (err: any) {
                setError(err.message || "Erreur lors du chargement");
            } finally {
                setLoading(false);
            }
        };

        fetchDashboard();
    }, [token]);

    return { data, loading, error };
}

export function useClientDashboard() {
    const { token } = useToken();
    const [data, setData] = useState<ClientDashboardStats | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchDashboard = async () => {
            if (!token) {
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                const result = await dashboardService.getClientStats(token);
                setData(result);
            } catch (err: any) {
                setError(err.message || "Erreur lors du chargement");
            } finally {
                setLoading(false);
            }
        };

        fetchDashboard();
    }, [token]);

    return { data, loading, error };
}